// extracted by mini-css-extract-plugin
export default {"outerBox":"SectionWrapper_outerBox__lxv3-","sectionActionsTop":"SectionWrapper_sectionActionsTop__9kXHb","sectionActionsBottom":"SectionWrapper_sectionActionsBottom__-sip+"};